<template>
	<div class="index">
		<!-- banner图 -->
		<div class="newsCenterBanenr">
			<img src="../../assets/xiangning/djbk/djbk_banner.png">
		</div>
		<div class="home_wrap">
			<!-- djbk上方标题栏 -->
			<div class="news_title">
				<div class="title_left">
                            <img src="../../assets/xiangning/home/titile_left.png" alt="">
						</div>
				<div class="news_title_left">
					<div v-for="item in djbkClassList" @click="changeNewsNum(item.class_id)" class="news_title_left_text"
						:style="{ color: NewsNum == item.class_id ? '#D31813' : '#999999', fontWeight: NewsNum == item.class_id ? '800' : '400',fontSize:'14px', padding:'0 8px',lineHeight:'22px'}">
						{{ item.title }}</div>

				</div>
				<div class="right_back" @click="goHome">
					<div class="right_back_icon"><img src="../../assets/xiangning/dwgk/back.png" alt=""></div>
					<div>返回</div>
				</div>
			</div>

			<!-- 党建百科内容 -->
			<div class="djbk_content">
				<!-- 新闻列表 -->
				<div class="djbk_content_item" v-for="(item, index) in dataList" :key="item.id">
					<div class="djbk_content_item_right">
						<div class="djbk_content_item_right_toptitle"> {{ item.title }}
						</div>
						<div class="djbk_content_item_right_center" :class="{ active: item.HeightNum != item.id }">
							{{ item.content }}
						</div>
						<div v-if="item.HeightNum != item.id" @click="changeHeight(item.id, index)"
							class="djbk_content_item_right_bottom">
							<div class="text">展开 </div>
							<div class="icon">
								<img src="../../assets/xiangning/djbk/donw.png" alt="">
							</div>
						</div>
						<div v-if="item.HeightNum == item.id" @click="changeHeight(0, index)"
							class="djbk_content_item_right_bottom">
							<div class="text">收起 </div>
							<div class="icon2">
								<img src="../../assets/xiangning/djbk/donw.png" alt="">
							</div>
						</div>
					</div>
				</div>

			</div>
			<!-- 下方分页器 -->
			<Page :total="total" :per_page="per_page" :pageSize="[10]" @handleCurrentChange="handleCurrentChange">
			</Page>
		</div>

	</div>
</template>
<script>
import Swiper from 'swiper';
import { news } from '@/axios';
import Page from '@/components/page.vue'
import { get } from '../../axios/api';
export default {
	data() {
		return {
			// 总数据条数
			total: 0,
			// 当前页码
			per_page: 1,
			// 标题栏切换改变样式
			NewsNum: 1,
			djbkClassList: [],
			index: 0,
			//模拟列表数据
			contentList: [
				{ id: 1 },
				{ id: 2 },
				{ id: 3 },
				{ id: 4 },
			],
			ChangeHeightNum: 0,
			dataList: []
		}
	},
	components: { Page },
	methods: {
		// 点击新闻中心切换标题
		changeNewsNum(val) {
			this.NewsNum = val
			this.per_page = 1
			this.getDjbkList()
		},
		//   分页器页码发生变化
		handleCurrentChange(val) {
			this.per_page = val
			this.getDjbkList()
		},
		goHome() {
			this.$router.push({
				path: '/home'
			})
		},
		// 点击展开及收起切换状态
		changeHeight(id, index) {
			// console.log(val);
			// this.ChangeHeightNum=val
			// console.log(this.dataList);
			// console.log(index);
			// this.dataList[index]
			this.dataList[index].HeightNum = id

			this.$forceUpdate()
		},
		// 获取党建百科分类
		getDjbkClass() {
			let that = this
			news.djbkClass().then((res) => {

				if (res.code == 200) {
					that.djbkClassList = res.data
					that.NewsNum = res.data[0].class_id
					if (this.$route.query.class_id) {
						this.NewsNum = this.$route.query.class_id
					} else {
						that.NewsNum = res.data[0].class_id
					}
					this.getDjbkList()
				}
			})
		},
		// 获取党建百科列表
		getDjbkList() {
			let that = this
			news.djbkList({ class_id: that.NewsNum, page: that.per_page }).then(res => {
				if (res.code == 200) {
					that.total = res.data.count
					that.dataList = res.data.pagedata
					that.dataList.forEach((item, index, arr) => {
						arr[index].HeightNum = 0
					});

				}

			})
		}
	},
	mounted() {

		this.getDjbkClass()
	},
	created() {
		this.$emit("highLight", this.$route.query.index, "", "", "");
	}
}
</script>

<style lang="scss" scoped>
@import '@/common/index.scss';

.index {
	width: 100%;

	.newsCenterBanenr {
		position: relative;
		width: 100%;

		img {
			width: 100%;
			height: auto;
		}

	}

	div {
		box-sizing: border-box;
	}

	.home_wrap {
		width: $indexWidth;
		margin: auto;
		min-width: 1200px;

		.news_title{
				height: 32px;
				width: 100%;
				margin:20px 0;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding-left:32px;
				background: #FFF6F1;
				box-sizing: border-box;
				position: relative;
				.title_left{
					position: absolute;
					top: -5px;
					left: 0;
					height: 42px;
					width: 42px;
					img{
						width: 100%;
						height: 100%;
					}
				}
			}
			.news_title_left{
				// width: 300px;
				height: 22px;
			
				// padding-left: 20px;
				display: flex;
				justify-content: space-between;
				
			}
		.news_title_left_text {
			height: 22px;
			// width: 80px;
			padding: 0 20px;
			font-family: PingFangSC-Regular;
			font-size: 16px;
			font-weight: normal;
			letter-spacing: 0.1em;
			color: #999999;
			cursor: pointer;
		}

		.right_back {
			display: flex;
			font-family: PingFangSC-Regular;
			font-size: 12px;
			font-weight: normal;
			letter-spacing: 0em;
			color: #666666;
			margin-right: 10px;
		}

		.right_back:hover {
			font-weight: 800;
			color: #EE632B;
		}

		.right_back_icon {
			height: 10px;
			width: 12px;
			margin-right: 5px;
		}

		.right_back_icon img {
			height: 100%;
			width: 100%;
		}

		/* 内容部分样式 */
		.djbk_content {
			width: 100%;
			overflow: hidden;
			margin-bottom: 20px;

			.djbk_content_item {
				width: 100%;
				border-bottom: 1px solid #ECEEF4;

				.djbk_content_item_right {
					height: 100%;
					width: 100%;

					.djbk_content_item_right_toptitle {
						margin-top: 10px;
						height: 20px;
						width: 80%;
						font-family: PingFangSC-Medium;
						font-size: 16px;
						font-weight: 800;
						letter-spacing: 0px;
						color: #000000;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
					}

					.djbk_content_item_right_toptitle:hover {
						color: #C9010A;
					}

					.djbk_content_item_right_center {
						margin-top: 20px;
						margin-bottom: 20px;
						text-indent: 24px;
						/* height: 173px; */
						font-family: PingFangSC-Regular;
						font-size:14px;
						font-weight: normal;
						line-height: 26px;
						text-align: justify;
						/* 浏览器可能不支持 */
						letter-spacing: 0px;
						color: #666666;
						/* overflow: hidden;
							text-overflow:ellipsis; 
							display:-webkit-box;  
							-webkit-box-orient:vertical;  
							-webkit-line-clamp:3;   */
					}

					.active {
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 3;
					}

					.djbk_content_item_right_bottom {

						margin-bottom: 10px;
						display: flex;
						justify-content: center;
						align-items: center;
						font-family: PingFangSC-Regular;
						font-size: 14px;
						font-weight: normal;
						letter-spacing: 0em;
						color: #EE632B;
					}

					.djbk_content_item_right_bottom .icon {
						width: 6px;
						height: 3px;
						position: relative;
						margin-left: 5px;

						img {
							position: absolute;
							top: 0px;
						}
					}

					.djbk_content_item_right_bottom .icon2 {
						margin-left: 5px;
						width: 6px;
						height: 3px;
						position: relative;
						-moz-transform: rotate(-180deg);
						-webkit-transform: rotate(-180deg);

						img {
							position: absolute;
							top: 0px;
						}
					}
				}
			}
		}


	}
}</style>
